// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__9zTMQ","label":"SetPasswdForm_label__3yyfi"};